export default [
	{
		path: "/dashboard",
		name: "Dashboard",
		component: () => import("../views/Index2"),
		meta: { isAuthenticated: true }
	},
];
  